// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageBox_root__1lRP6","iconBox":"MessageBox_iconBox__1s-Ez","message":"MessageBox_message__Zuwc-","error":"MessageBox_error__M7JXR","success":"MessageBox_success__2eAcc"};